<template>
  <div class="tree-form-tree-container">
    <!-- TODO: need refine -->
    <!-- <div v-if="API.form.content"> -->
    <div>
      <el-form ref="form" label-width="150px" label-position="right" :model="API.form.content">
        <!-- <el-form-item v-for="(item, index) of API.form.content" :key="index" :label="index">  -->
        <el-form-item v-for="(item, index) of API.form.content" :key="index" :label="API.form.attributesTextMap[index]"
          :prop="'[' + index + ']'" :rules="rules[index]"
          v-if="!API.form.formItemFilter.includes(index)" >
          <el-select v-model="API.form.content[index]" v-if="index === 'type'" :disabled="(API.form.content.children && API.form.content.children.length > 0)">
            <el-option label="周" value="week" ></el-option>
            <el-option label="小时" value="time" ></el-option>
          </el-select>
          <el-checkbox-group v-else-if="index === 'value' && API.form.content.timeSharingType === 'week'" v-model="API.form.content[index]">
            <el-checkbox label="星期一"></el-checkbox>
            <el-checkbox label="星期二"></el-checkbox>
            <el-checkbox label="星期三"></el-checkbox>
            <el-checkbox label="星期四"></el-checkbox>
            <el-checkbox label="星期五"></el-checkbox>
            <el-checkbox label="星期六"></el-checkbox>
            <el-checkbox label="星期日"></el-checkbox>
          </el-checkbox-group>
          <div class="time-picker-container" v-else-if="index === 'value' && API.form.content.timeSharingType === 'time'">
            <div class="warpper">
              <div v-for="(timeItem, timeIndex) of API.form.content[index]" :key="timeIndex">
                <el-time-select placeholder="起始时间" v-model="API.form.content[index][timeIndex][0]" :editable="false" :clearable="false" :picker-options="{
                start: '00:01',
                step: '00:01',
                end: '24:00',
                maxTime: API.form.content[index][timeIndex][1]}" popper-class="energy-price-popper"></el-time-select>
                <el-time-select placeholder="结束时间" v-model="API.form.content[index][timeIndex][1]" :editable="false" :clearable="false" :picker-options="{
                start: '00:01',
                step: '00:01',
                end: '24:00',
                minTime: API.form.content[index][timeIndex][0]}" popper-class="energy-price-popper"></el-time-select>
                <el-button icon="el-icon-close" @click="removeTime(index, timeIndex)"></el-button>
              </div>
            </div>
            <el-button @click="addTimeSharing">添加时段</el-button>
          </div>
          <el-input v-model="API.form.content[index]" v-else-if="typeof item === 'string'" maxlength="16" placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-if="API.form.content" @click="sharingSave" :disabled="!ready">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
const moment = require('moment')
export default {
  name: 'TreeFormForm',
  props: ['API'],
  data () {
    // const checkKeyInUse = (rules, value, cb) => {
    //   let inUse = 0
    //   for (const item of this.API.form.childrenKeys) {
    //     if (value === item.key) {
    //       if (!this.API.form.content.id) {
    //         inUse++
    //       } else if (this.API.form.content.id !== item.id) {
    //         inUse++
    //       }
    //     }
    //   }
    //   if (inUse > 0) {
    //     cb(new Error('key in use'))
    //   } else {
    //     cb()
    //   }
    // }
    const checkKeyName = (rules, value, cb) => {
      for (const item of this.treeName) {
        if (this.API.form.content.id) {
          if (this.API.form.content.id !== item.id && item.label === value) {
            cb(new Error('分时名称不可重复，请重新输入'))
          }
        } else {
          if (item.label === value) {
            cb(new Error('分时名称不可重复，请重新输入'))
          }
        }
      }
      cb()
    }
    const checkName = (rules, value, cb) => {
      if (value.trim() === '') {
        cb(new Error('名称不可为空，请输入'))
      } else {
        cb()
      }
    }
    // const checkNameInUse = (rules, value, cb) => {
    //   let inUse = 0
    //   for (const item of this.API.treeData) {
    //     if (value === item.name) {
    //       if (!this.API.form.content.id) {
    //         // inUse++
    //       } else if (this.API.form.content.id !== item.id) {
    //         inUse++
    //       }
    //     }
    //   }
    //   console.log(inUse)
    //   if (inUse > 0) {
    //     cb(new Error('key in use'))
    //   } else {
    //     cb()
    //   }
    // }
    return {
      formData: {},
      treeName: [],
      rules: {
        key: [{ required: true, message: '请输入分时名称', trigger: 'blur' },
          { validator: checkKeyName, trigger: 'blur' },
          { validator: checkName, trigger: 'blur' }
        ],
        name: [{ required: true, message: '请输入分时名称', trigger: 'blur' },
          { validator: checkKeyName, trigger: 'blur' },
          { validator: checkName, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ready () {
      // this.formData = Object.assign({}, this.API.form.content)
      if (this.API.form.content && (this.API.form.content.name || this.API.form.content.key)) {
        return true
      } else {
        return false
      }
    }
  },
  created () {
    // this.formData = Object.assign({}, this.API.form.content)
    this.getTreeName(this.API.treeData)
    console.log(this.API.treeData, 'this.API.treeData')
  },
  methods: {
    getTreeName (data) {
      for (const item of data) {
        this.treeName.push({ id: item.id, label: item.label })
        if (item.children && item.children.length > 0) {
          this.getTreeName(item.children)
        }
      }
    },
    verifyTime (index) {
      if (moment(this.API.form.content.value[index][0], 'HH:mm').valueOf() === moment(this.API.form.content.value[index][1], 'HH:mm').valueOf()) {
        this.API.form.content.value[index][1] = moment(this.API.form.content.value[index][1], 'HH:mm').add(1, 'hours').format('HH:mm')

        this.$forceUpdate()
      }
      // console.log(this.API.form.content.value[index])
    },
    addTimeSharing () {
      this.API.form.content.value.push([moment().startOf('day').add(1, 'm').format('HH:mm'), moment().startOf('day').add(8, 'hours').format('HH:mm')])
    },
    sharingSave () {
      if (this.API.form.content.timeSharingType === 'week' && Array.isArray(this.API.form.content.value[0])) {
        this.API.form.content.value.shift()
      }
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.API.form.content.key) {
            this.API.form.content.key = this.API.form.content.key.trim()
            this.API.form.content.label = this.API.form.content.label.trim()
          }
          if (this.API.form.content.name) {
            this.API.form.content.name = this.API.form.content.name.trim()
          }
          for (const item of this.treeName) {
            if (this.API.form.content.id) {
              if (this.API.form.content.id !== item.id && item.name === this.API.form.content.label) {
                this.$message.error('分时名称不可重复')
                return false
              }
            } else {
              if (item.name === this.API.form.content.label) {
                this.$message.error('分时名称不可重复')
                return false
              }
            }
          }
          console.log(this.API.form.content, '-----提交')
          const tempData = []
          let index = 0
          if (this.API.form.content.value && this.API.form.content.timeSharingType === 'time') {
            for (const item of this.API.form.content.value) {
              if (item[0] === '' || item[1] === '') {
                this.$message.error('时段不可为空,请选择')
                return false
              }
              const t = {
                one: item[0],
                two: item[1],
                index: index++
              }
              tempData.push(t)
            }
            console.log(tempData)
            for (const item of tempData) {
              for (const v of tempData) {
                if (item.index !== v.index) {
                  if (item.one === v.one && item.two === v.two) {
                    this.$message.error('不可重复添加相同时段')
                    return false
                  }
                }
              }
            }
          }
          this.API.handleFormSubmit(this.API)
        }
      })
    },
    removeTime (index, tsIndex) {
      this.API.form.content[index].splice(tsIndex, 1)
      console.log(index, tsIndex)
    }
  }
}
</script>

<style lang="scss" scoped>
.tree-form-tree-container {
  max-height: 100%;
  flex: auto;
  padding: 0 20px;
  overflow-y: auto;
  h1 {
    margin-top: 0;
  }
  .form-container-with-table {
    padding-right: 5px;
    height: 50%;
    overflow-y: auto;
  }
  .warpper {
    display: flex;
    flex-direction: column;
    * {
      margin-bottom: 10px;
    }
  }
}
</style>

<style rel="stylesheet/scss" lang="scss">
.energy-price-popper {
  .el-scrollbar__bar.is-vertical {
    width: 10px;
    background: rgba(62, 163, 213, 0.16);
    .el-scrollbar__thumb {
      background-color: red;
      box-shadow: 0 0 8px red;
      border: 0.3px solid red;
    }
  }
}
</style>
